import React, { useState } from 'react';

import { Autocomplete, TextField, Chip, Box } from '@mui/material';
import Button from 'components/Button/Index';

import './Index.scss';
import { SkillService } from 'services/skills/skillService';
import { GeneralSkillPopup } from 'core/interface/general-skills';
import { CandidateService } from 'services/candidate/candidate';
import colors from 'assets/variables/colors';

const GeneralSkillsPopup: React.FC<GeneralSkillPopup> = ({
  t,
  handleClose,
  candidateId,
  skillCategory,
  existingHardSkills = [],
  existingSoftSkills = []
}) => {
  const [freeSoloInput, setFreeSoloInput] = useState<string[]>(
    skillCategory === 'hard_skills' ? existingHardSkills : existingSoftSkills
  );

  const handleFreeSoloChange = (event: any, value: string[]) => {
    setFreeSoloInput(value);
  };

  const handleSaveSkills = async () => {
    try {
      // Filter out any empty strings or duplicates
      const uniqueSkills = Array.from(
        new Set(freeSoloInput.filter((skill) => skill.trim()))
      );

      // Preserve existing skills of the other category
      const hardSkills =
        skillCategory === 'hard_skills' ? uniqueSkills : existingHardSkills;
      const softSkills =
        skillCategory === 'soft_skills' ? uniqueSkills : existingSoftSkills;

      await SkillService.addGeneralSkill(candidateId, hardSkills, softSkills);
      await CandidateService.getCandidate(candidateId);

      if (handleClose) {
        handleClose();
      }
    } catch (error) {
      console.error('Error saving skills:', error);
    }
  };

  const currentSkills =
    skillCategory === 'hard_skills' ? existingHardSkills : existingSoftSkills;

  return (
    <Box className="freesolo-skills" sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h3 className="skills-label">{t('Add Skills')}</h3>
      </Box>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={freeSoloInput}
        onChange={handleFreeSoloChange}
        renderTags={(value: string[], getTagProps) =>
          value.map((option: string, index: number) => {
            const isExisting = currentSkills.includes(option);
            return (
              <Chip
                label={option}
                {...getTagProps({ index })}
                key={option}
                sx={{
                  backgroundColor: isExisting
                    ? colors.lightPurple
                    : colors.softPurple,
                  borderRadius: '60px',
                  height: '47px',
                  color: colors.tenantColor,
                  marginTop: '40px'
                }}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            className="skills-autocomplete"
            {...params}
            variant="outlined"
            placeholder={t('Add tags...')}
          />
        )}
      />
      <div className="helper-text-container">
        <p className="helper-text">
          {t('For each skill, press Enter to add tag.')}
        </p>
      </div>
      <Button
        onClick={handleSaveSkills}
        t={t}
        type="submit"
        title="Save"
        className="save-button"
      />
    </Box>
  );
};

export default GeneralSkillsPopup;
